import React from "react";
import { Container } from "react-bootstrap";
import styled from "styled-components";

import { CurveDivider } from "./core";
import { DarkCBKIcon, LogoIconLightText } from "./core/icons";

type SinglePageContainerProps = {
    children: React.ReactNode;
};

const SinglePageContainer = ({
    children,
}: SinglePageContainerProps): JSX.Element => {
    return (
        <Container
            fluid
            className="vh-100 px-0 position-relative d-flex flex-column"
        >
            <Header className="bg-dark position-relative px-5 py-2 flex-shrink-0">
                <LogoIconLightText />
                <Divider className="position-absolute start-0 end-0 bottom-0" />
            </Header>
            <main>
                <div className="flex-grow-1">{children}</div>
            </main>
            <div className="bg-background-grey start-0 end-0 bottom-0 text-center">
                <DarkCBKIcon className="mb-3" />
            </div>
        </Container>
    );
};

const Header = styled.div`
    height: 80px;
`;

const Divider = styled.div`
    height: 32px;
    background-color: var(--bs-background-grey);
    ${CurveDivider("--bs-background-grey", 32)};
    transform: scaleY(-1);

    ::before {
        left: 0;
        top: 32px;
    }
`;

export default SinglePageContainer;
